import { createWebHistory, createRouter } from "vue-router";
import i82n from './i18n';
import Home from "./components/HomeIndex.vue";

export let historyStack = [];

const routes = [
    {
        path: "/",
        name: "Portfolio",
        component: Home,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    historyStack.push(to.fullPath);
    let route_name = i82n.global.t(to.name);
    document.title = 'Dani Andhika Permana' + ' | ' + route_name;
    to.meta.title = route_name;
    next();
});

export default router;